import { useSelector } from "react-redux";

export function ProductBasedRules() {
    const activeStep = useSelector((state) => state.visualizer.activeStep);
    const activeCommunity = useSelector((state) => state.visualizer.activeCommunity);


    const filterProduct = (product) => {
        let result = true;
        switch(activeStep.id){
            case 29:
                //Interior Door
                if(activeCommunity.includes('Beachview')){
                    //For Signature Series and Beachview Cove plans please mark 2 panel square as standard with no other options.
                    result = product.id != 5136586 && product.id != 5136584;
                    
                }
            break;
            default:
            result = true; 
        }
        return result;
    };

    const getTierString = (tierString,product) => {
        switch(activeStep.id){
            case 6:
            case 15:
                //kitchen floor
                //bathroom floor
                if(product.id == 5439281){
                    if((activeCommunity.includes('Beachview') || activeCommunity.includes('Signature'))){
                        //Ferrara Blanco has changed to an upgrade for regular SeaGate Plans including Matanzas Cove (it is a standard on Signature Series and Beachview Cove
                        tierString = 'Standard';
                    }
                    tierString = 'Upgrade';
                }
            break
            case 21:
                //shower floor
                if(product.id == 5136813){
                    if((activeCommunity.includes('Beachview') || activeCommunity.includes('Signature'))){
                        //Ferrara Blanco has changed to an upgrade for regular SeaGate Plans including Matanzas Cove (it is a standard on Signature Series and Beachview Cove
                        tierString = 'Standard';
                    }
                    tierString = 'Upgrade';
                }
                break;
            case 22:
                //shower wall
                if(product.id == 5136764){
                    if((activeCommunity.includes('Beachview') || activeCommunity.includes('Signature'))){
                        //Ferrara Blanco has changed to an upgrade for regular SeaGate Plans including Matanzas Cove (it is a standard on Signature Series and Beachview Cove
                        tierString = 'Standard';
                    }
                    tierString = 'Upgrade';
                }
                break;
            case 30:
                //Interior Door hardware
                if(activeCommunity.includes('Matanzas Cove') && product.id == 5451481){
                    //Matanzas Cove please mark the Balboa Lever in Satin Nickel as standard
                    tierString = 'Standard';
                    
                }
            break;
            case 32:
                //Chandeliers

                //Gulliver:This is only standard for Beachview Cove Plans. Please mark as upgrade.
                if(product.name == 'Gulliver4Light'){
                    tierString = 'Upgrade';
                    if(activeCommunity.includes('Beachview'))
                        tierString = 'Standard';
                }
                //Trinity: This is only standard for Signature Series Plans. Please mark as upgrade.
                if(product.name == 'Trinity'){
                    tierString = 'Upgrade';
                    if(activeCommunity.includes('Signature'))
                        tierString = 'Standard';
                }
            break;
        }
        return tierString;
    };

    return { filterProduct, getTierString };
}
